<template>

  <el-row :gutter="gutter">
    <div class="dash-heading">Financial Statement</div>

    <el-col ref="summaryCard" align="center" :span="24">

      <el-card class="box-card" shadow="hover" body-style="height: 35em;">
        <div slot="header" class="clearfix">
          <h4>Invoice Summary</h4>
        </div>

        <el-row align="bottom" justify="center">
          <el-col align="left" :sm="12" :md="12" :lg="10">
            <h4 style="line-height: 36px;">Sharer Billing&nbsp;</h4>
          </el-col>
          <el-col align="right" :sm="12" :md="12" :lg="14">
            <span :style="'font-size: ' + textSize + '; color: slateblue;'">{{formatMoney(dueFees, 0)}}</span>
          </el-col>
        </el-row>

        <el-row align="bottom" justify="center">
          <el-col align="left" :sm="12" :md="12" :lg="10">
            <h4>Received to Date:&nbsp;</h4>
          </el-col>
          <el-col align="right" :sm="12" :md="12" :lg="14">
            <span :style="'font-size: ' + textSize + '; color: seagreen;'">{{formatMoney(paidFees, 0)}}</span>
          </el-col>
        </el-row>

        <el-row align="bottom" justify="center">
          <el-col align="left" :sm="12" :md="12" :lg="10">
            <h4>Outstanding:&nbsp;</h4>
          </el-col>
          <el-col align="right" :sm="12" :md="12" :lg="14">
            <span :style="'font-size: ' + textSize + '; color: goldenrod;'">{{formatMoney(outstandingFees, 0)}}</span>
          </el-col>
        </el-row>

        <br />

        <el-row v-if="hasUtilTransactions">
          <el-col align="left">
            <h4>{{utilLabel}} Invoicing</h4>
          </el-col>
          <el-col>
            <el-table
            :data="utilData"
            stripe
            style="width: 100%">
            <el-table-column
            prop="advance"
            label="Advance"
            align="right" />
            <el-table-column
            prop="sharing"
            label="Sharing"
            align="right" />
            <el-table-column
            prop="utility"
            :label="utilLabel + ' Due'"
            align="right" />
            <el-table-column
            prop="penalties"
            label="Penalties"
            align="right" />
          </el-table>
        </el-col>
      </el-row>

      <br />
      <el-row>
        <el-col align="left" :sm="12" :md="12" :lg="10">
          <h4>Total Invoicing</h4>
        </el-col>
        <el-col align="right" :sm="12" :md="12" :lg="14">
          <span :style="'font-size: ' + textSize + '; color: slateblue;'">{{formatMoney(totalInvoicing, 0)}}</span>
        </el-col>
        </el-row>

        <el-row>
        <el-col align="left" :sm="12" :md="12" :lg="10">
          <h4>Total Paid</h4>
        </el-col>
        <el-col align="right" :sm="12" :md="12" :lg="14">
          <span :style="'font-size: ' + textSize + '; color: seagreen;'">{{formatMoney(totalPaid, 0)}}</span>
        </el-col>
      </el-row>

      <el-row>
        <div style="border-style: solid; border-width:1px; border-color: lightgrey; margin-top: 0.7em; margin-bottom: 0.7em;"></div>
        <el-col align="left" :sm="12" :md="12" :lg="10">
          <h4>Balance</h4>
        </el-col>
        <el-col align="right" :sm="12" :md="12" :lg="14">
          <span :style="'font-size: ' + textSize + '; color: indianred;'">{{formatMoney(totalInvoicing - totalPaid, 0)}}</span>
        </el-col>
      </el-row>

      <el-row v-if="this.percent > 0" style="padding-top: 2em;">
         <el-progress :text-inside="true" :stroke-width="18" :percentage="Number(percent)" :status="dueStatus"></el-progress>
      </el-row>

    </el-card>

  </el-col>


  <el-col ref="gridCard" align="left" :sm="24" :md="24" :lg="12">

      <br />

      <el-card class="card"  shadow="hover">
        <div slot="header" class="clearfix">
          <h4>Breakdown by Sharer</h4>
        </div>

        <el-table
          :data="orgData"
          stripe
          border
          height="490"
          show-summary
          sum-text="Total"
          :summary-method="totaller"
          style="width: 100%">

        <el-table-column
        prop="name"
        label="Name" />
        <el-table-column
        prop="invoiced"
        label="Invoiced"
        align="right" />
        <el-table-column
        prop="paid"
        label="Paid"
        align="right" />
      <el-table-column
        prop="outstanding"
        label="O/S"
        align="right" />

      </el-table>
    </el-card>

  </el-col>

  <el-col v-if="charts" ref="pieChartCard" style="width: 50%;" align="center" :sm="24" :md="24" :lg="12">

    <br />

    <pie-chart :data="charts"
      :donut="true"
      thousands=","
      legend="bottom"
      :download="false" />

  </el-col>

</el-row>

</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'

export default {

  mixins: [SiteMixins],

  methods: {
    setStatement (statement) {
      this.summary = statement

      this.utilData.push({'advance': this.formatMoney(this.dueAdvance, 0),
        'sharing': this.formatMoney(this.dueSharing, 0),
        'utility': this.formatMoney(this.owingUtility, 0),
        'penalties': this.formatMoney(this.owingPenalties, 0)})

      this.hasUtilTransactions = (this.dueAdvance > 0 || this.dueSharing > 0)

      this.fillOrgData()

      this.dueStatus = this.percent < 20 ? 'success' : (this.percent <= 30 ? 'default' : 'exception')

    },

    fillOrgData () {
      var orgs = []

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].ledger === 'CR') {

            if (!orgs.includes(this.summary[i].shortName)) {
              orgs.push(this.summary[i].shortName)
            }

          }
        } // for
      }

      if (this.summary.length > 0 && orgs.length > 0) {

        for (var o = 0, ln = orgs.length; o < ln; o++) {
          var invoiced = 0
          var paid = 0
          var due = 0
          var name = orgs[o]

          for (i = 0, len = this.summary.length; i < len; i++) {

            if (this.summary[i].shortName === name) {
              invoiced += this.summary[i].total ? Number(this.summary[i].total) : 0
              paid += this.summary[i].totalPaid ? Number(this.summary[i].totalPaid) : 0
              due += this.summary[i].outstanding ? Number(this.summary[i].outstanding) : 0
            }

          }  // for summary

          this.charts.push([name, invoiced])

          this.orgData.push({'name': name,
            'invoiced': invoiced > 0 ? this.formatInteger(invoiced) : '',
            'paid': paid > 0 ? this.formatInteger(paid) : '',
            'outstanding': (invoiced - Math.abs(due)) !== 0 ? this.formatInteger(due) : ''})

        } // for orgs
      }

    },


    totaller (param) {
      const { columns, data } = param
      const sums = []

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Total'
          return
        }

        const values = data.map(item => this.toNumber(item[column.property]))

        if (!values.every(value => isNaN(value))) {
          sums[index] = this.formatInteger(values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0))
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    }

  },



  computed: {

    dueAdvance: function () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].type === 'A' && this.summary[i].ledger === 'CR') {
            res += this.summary[i].total ? Number(this.summary[i].total) : 0
          }
        }
      }

      return res
    },


    dueSharing: function () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].type === 'U' && this.summary[i].ledger === 'CR') {
            res += this.summary[i].total ? Number(this.summary[i].total) : 0
          }
        }
      }

      return res
    },


    dueFees: function () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].type === 'L' && this.summary[i].ledger === 'CR') {
            res += this.summary[i].total ? Number(this.summary[i].total) : 0
          }
        }
      }

      return res
    },


    paidFees: function () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].type === 'L' && this.summary[i].ledger === 'CR') {
            res += this.summary[i].totalPaid ? Number(this.summary[i].totalPaid) : 0
          }
        }
      }

      return res
    },


    totalPaid: function () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].ledger === 'CR') {
            res += this.summary[i].totalPaid ? Number(this.summary[i].totalPaid) : 0
          }
        }
      }

      return res
    },


    outstandingFees: function () {
      return this.dueFees - this.paidFees
    },


    totalInvoicing: function () {
      return Number(this.dueFees + this.dueAdvance + this.dueSharing)
    },


    owingUtility: function () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].type === 'U' && this.summary[i].ledger === 'DR') {
            res += this.summary[i].outstanding ? Number(this.summary[i].outstanding) : 0
          }
        }
      }

      return Math.abs(res)
    },

    owingPenalties: function () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          res += Math.abs(Number(this.summary[i].penalties))
        }
      }

      return res
    },

    owingOutstanding: function () {
      var res = 0

      if (this.summary.length > 0) {
        for (var i = 0, len = this.summary.length; i < len; i++) {
          if (this.summary[i].type === 'U' && this.summary[i].ledger === 'CR') {
            res += this.summary[i].outstanding ? Number(this.summary[i].outstanding) : 0
          }
        }
      }

      return res
    },

    percent: function () {
      var res = parseFloat(((this.totalInvoicing - this.totalPaid) / this.totalInvoicing) * 100).toFixed(2)

      if (isNaN(res) || !res) {
        return 0
      } else {
        return res
      }

    }
  },


  data () {
    return {
      hasUtilTransactions: false,
      dueStatus: 'exception',
      gutter: 16,
      textSize: '1.7em',
      utilLabel: this.getUtilLabel(),
      summary: [],
      utilData: [],
      charts: [],
      orgData: [],
      options: {
        fullWidth: true,
        showLabel: true
      }
    }
  },


  mounted () {
    this.findFinanceSummary(this.setStatement)
  }


}

</script>
